import {createAction} from 'redux-act';

export const GET_SALES_PER_HOUR = createAction(
  'analyticsSalesPerHour/GET_SALES_PER_HOUR'
);
export const GET_SALES_PER_HOUR_SUCCESS = createAction(
  'analyticsSalesPerHour/GET_SALES_PER_HOUR_SUCCESS'
);
